module.exports = __webpack_public_path__ + "static/media/9.381bcde7.jpg";